module.exports = __webpack_public_path__ + "img/img_ohter_guide@2x.555b4ee6.png";